import { render, staticRenderFns } from "./SkillsTwo.vue?vue&type=template&id=85b9dabe&scoped=true&"
import script from "./SkillsTwo.vue?vue&type=script&lang=js&"
export * from "./SkillsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b9dabe",
  null
  
)

export default component.exports